export default __webpack_public_path__ + "static/media/Pot3.a884043d.svg";